import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clsx } from "clsx";
import { emitJoinGame } from "../../reducers/gameSlice";
import { emitIsRoomCodeValid, emitIsPlayerNameAvailable } from "../../reducers/appSlice";
// import { getRandomName } from "../../utilities/nameGenerator";
import CloseIcon from "../../icons/close.svg";

function JoinGame(props) {
	const dispatch = useDispatch();
	const errorMessage = useSelector(state => state.app.error);
	const [room, setRoom] = useState("");
	const [playerName, setPlayerName] = useState("");
	const isRoomCodeValid = useSelector(state => state.app.roomCodeValid);
	const isPlayerNameAvailable = useSelector(state => state.app.playerNameAvailable);
	const codeLimit = 6;
	const minNameLength = 5;
	const isPlayerNameValid = isPlayerNameAvailable && playerName.length >= minNameLength;
	const canJoin = isRoomCodeValid && isPlayerNameValid;
	const nameLimitString = "Name must be at least 5 characters";

	function handleRoomCode(event) {
		const code = (event.target.value = event.target.value.toUpperCase());
		setRoom(code);
		dispatch(emitIsRoomCodeValid({ roomCode: code }));
	}

	function handlePlayerNameChange(event) {
		const name = event.target.value;
		setPlayerName(name);
		dispatch(emitIsPlayerNameAvailable({ roomCode: room, playerName: name }));
	}

	function joinGameRoom() {
		if (isPlayerNameValid) {
			dispatch(emitJoinGame({ roomCode: room, playerName: playerName }));
		}
	}

	const style = {
		generateNameButton:
			"py-2 px-9 content-center text-slate-100 text-xl font-bold bg-blue-500 hover:bg-blue-600 rounded-md",
		errorText: "text-red-600 text-xs mt-2 self-end",
		form: {
			container: "flex flex-col lg:w-1/3 w-9/10",
			label: "mb-2 text-sm font-semibold self-start",
			input: "placeholder:italic text-center py-2 px-2 bg-white rounded outline focus:outline-3 outline-blue-600",
			inputError: "outline-red-600",
		},
	};

	// TODO: Check if playerName contains non alphanumeric characters

	return (
		<div className={props.modalStyle.container}>
			<div className={props.modalStyle.closeContainer} onClick={props.closeModal}>
				<CloseIcon className={props.modalStyle.closeIcon} />
			</div>
			<div className="flex flex-col h-9/10 w-full px-4 justify-around">
				<h1 className="my-4 text-3xl font-medium text-gray-600 w-full">Join Game</h1>
				<div className="flex flex-col gap-y-4 items-center ">
					<div className={style.form.container}>
						<label className={style.form.label}>Room Code</label>
						<input
							className={clsx(style.form.input, room.length > 0 && !isRoomCodeValid && style.form.inputError)}
							type="text"
							placeholder="Room Code"
							name="room-code"
							maxLength={codeLimit}
							onChange={handleRoomCode}></input>
						{room.length > 0 && !isRoomCodeValid ? <div className={style.errorText}>Room code is not valid</div> : null}
					</div>
					<div className={style.form.container}>
						<label className={style.form.label}>Player Name</label>
						<input
							className={clsx(
								`${style.form.input} py-2 px-2 rounded text-center`,
								playerName.length > 0 && playerName.length < minNameLength && !isPlayerNameAvailable
									? style.form.inputError
									: "",
							)}
							type="text"
							placeholder={"Player Name"}
							value={playerName}
							maxLength={25}
							onChange={handlePlayerNameChange}></input>
						{playerName.length > 0 && playerName.length < minNameLength ? (
							<div className={style.errorText}>{nameLimitString}</div>
						) : null}
						{!isPlayerNameAvailable ? <div className={style.errorText}>Name already in use</div> : null}
					</div>
				</div>
				<section className="text-sm lg:text-base">
					Please choose a name to go by during the game (a name of at least 5 characters). Other players may want to
					call on you by name, so use your own name or chose a nickname you are comfortable with. Also, if you are
					playing for educational credit, your instructor needs to identify you; best to use the same name across all
					games you play in class.
				</section>
				<div className="mt-4">
					<button
						className={clsx(
							"py-2 px-10 content-center text-xl text-slate-100  font-bold rounded-md",
							canJoin
								? "bg-blue-500 hover:bg-blue-600 cursor-pointer"
								: "bg-blue-800 hover:bg-blue-900 cursor-not-allowed",
						)}
						disabled={!canJoin}
						onClick={joinGameRoom}>
						Join
					</button>
				</div>
				<div className="text-red-600">{errorMessage}</div>
			</div>
		</div>
	);
}

export default JoinGame;
